import React from 'react';
import LiteralsService from 'src/services/literals/LiteralsService';
import LightningIcon from 'src/assets/png/lightning-icon.png';
import { goToBudgetCategoryTransactions } from 'src/services/router.service';
import Selectors from 'src/utils/selectors';
import CalloutGray from 'src/components/atomic/atoms/calloutGray/CalloutGray';
import { useHistory } from 'react-router';
import { ButtonSecondary, GlyphRight } from '@americanexpress/dls-react';
import styles from 'src/components/atomic/molecules/wrongNumbersCallout/wrongNumbersCallout.module.scss';
import { DLSSize } from 'src/types/dls-size.enum';
import { trackClick } from 'src/hooks/useAdobeTags';
import adobeTags from 'src/types/adobe-tags';

export default function WrongNumbersCallout(): JSX.Element {
    const history = useHistory();
    return (
        <CalloutGray
            data-cy={Selectors.SpendSmart.WRONG_NUMBERS_CALLOUT}
            heading={LiteralsService.getLiteral('WrongNumbersCallout.header')}
            body={LiteralsService.getLiteral('WrongNumbersCallout.body')}
            className={styles.callout}
            button={
                <ButtonSecondary
                    className={styles.button}
                    size={DLSSize.MEDIUM}
                    data-cy={Selectors.SpendSmart.CALLOUT_BUTTON}
                    onClick={() => {
                        trackClick(history.location.pathname, adobeTags.Callout.SeeTransactions);
                        goToBudgetCategoryTransactions(false, history);
                    }}
                >
                    {LiteralsService.getLiteral('WrongNumbersCallout.button')}
                    <GlyphRight className={styles.glyph} />
                </ButtonSecondary>
            }
            icon={
                <img
                    src={LightningIcon}
                    alt="Lightning Icon"
                    className={styles.icon}
                    data-cy={Selectors.SpendSmart.CALLOUT_ICON}
                />
            }
        />
    );
}
